// Lightweight Web Audio click generator for the metronome.
// Generates a sharp, ball-strike style tick with no external assets.
let audioCtx = null;

function getCtx() {
  if (audioCtx) return audioCtx;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  audioCtx = new Ctx();
  return audioCtx;
}

export function unlockAudio() {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume();
}

/**
 * Play a punchy "ball-master" click.
 * Two layered sounds:
 *  - low-frequency thump (kick)
 *  - short high-frequency click (snap)
 */
export function playTick(accent = false) {
  const ctx = getCtx();
  if (!ctx) return;
  const now = ctx.currentTime;

  // Master gain stage so we can push volume safely with a soft limiter
  const master = ctx.createGain();
  master.gain.value = 1.0;
  const limiter = ctx.createDynamicsCompressor();
  limiter.threshold.setValueAtTime(-6, now);
  limiter.knee.setValueAtTime(8, now);
  limiter.ratio.setValueAtTime(12, now);
  limiter.attack.setValueAtTime(0.002, now);
  limiter.release.setValueAtTime(0.12, now);
  master.connect(limiter).connect(ctx.destination);

  // Low thump (kick)
  const osc1 = ctx.createOscillator();
  const gain1 = ctx.createGain();
  osc1.type = "sine";
  osc1.frequency.setValueAtTime(accent ? 240 : 170, now);
  osc1.frequency.exponentialRampToValueAtTime(55, now + 0.09);
  gain1.gain.setValueAtTime(0.0001, now);
  gain1.gain.exponentialRampToValueAtTime(accent ? 2.0 : 1.5, now + 0.005);
  gain1.gain.exponentialRampToValueAtTime(0.0001, now + 0.22);
  osc1.connect(gain1).connect(master);
  osc1.start(now);
  osc1.stop(now + 0.24);

  // High snap (square click)
  const osc2 = ctx.createOscillator();
  const gain2 = ctx.createGain();
  osc2.type = "square";
  osc2.frequency.setValueAtTime(accent ? 2000 : 1500, now);
  gain2.gain.setValueAtTime(0.0001, now);
  gain2.gain.exponentialRampToValueAtTime(accent ? 0.95 : 0.65, now + 0.002);
  gain2.gain.exponentialRampToValueAtTime(0.0001, now + 0.06);
  osc2.connect(gain2).connect(master);
  osc2.start(now);
  osc2.stop(now + 0.07);

  // Extra mid body for punch
  const osc3 = ctx.createOscillator();
  const gain3 = ctx.createGain();
  osc3.type = "triangle";
  osc3.frequency.setValueAtTime(accent ? 800 : 600, now);
  gain3.gain.setValueAtTime(0.0001, now);
  gain3.gain.exponentialRampToValueAtTime(accent ? 0.7 : 0.5, now + 0.003);
  gain3.gain.exponentialRampToValueAtTime(0.0001, now + 0.1);
  osc3.connect(gain3).connect(master);
  osc3.start(now);
  osc3.stop(now + 0.12);
}
